// Forked from ../../RecentSearches/RecentSearchItem.tsx — keep in sync until phase_0 cleanup.
import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import { IconRestore } from '@bynder/icons';
import { ListRow } from '../Results/ListRow';

interface Props {
	term: string;
	onSelect: () => void;
}

export function RecentSearchItem({ term, onSelect }: Props) {
	return (
		<ListRow
			dataId={term}
			thumbnail={<IconRestore style={{ color: token.colorTextMuted }} />}
			title={<StyledTerm>{term}</StyledTerm>}
			onSelect={onSelect}
		/>
	);
}

// List.Item sets colorText on its root, so the muted colour has to sit on our own title element.
const StyledTerm = styled.span`
	color: ${token.colorTextMuted};
`;
